import React from 'react';
import { Wind } from 'lucide-react';
import ProjectTemplate from './ProjectTemplate';

const Pulmo = () => {
  const project = {
    title: 'Yamai Pulmo',
    tagline: 'Smart Respiratory and Lung Function Analysis',
    icon: Wind,
    color: '#3B82F6',
    overview: 'Yamai Pulmo brings AI-powered analysis to respiratory medicine through automated interpretation of chest X-rays, CT scans, and pulmonary function tests. Our system assists in detecting pneumonia, COPD, lung cancer, tuberculosis, and other respiratory conditions with explainable diagnostic support.',
    problems: [
      {
        title: 'Global Respiratory Disease Burden',
        description: 'Respiratory diseases are among the leading causes of death worldwide, often detected too late for optimal treatment.',
      },
      {
        title: 'Radiologist Shortage',
        description: 'There aren\'t enough trained radiologists to handle the volume of chest imaging studies globally.',
      },
      {
        title: 'Subtle Early Signs',
        description: 'Early-stage lung conditions can present with very subtle imaging findings that are easily overlooked.',
      },
      {
        title: 'Inconsistent Screening',
        description: 'High-risk populations often lack access to regular lung cancer screening programs.',
      },
    ],
    solutions: [
      'Deep learning models trained to detect abnormalities in chest X-rays and CT scans',
      'Multi-disease classification including pneumonia, tuberculosis, lung nodules, pleural effusion, and more',
      'Automated lung nodule detection and measurement for cancer screening',
      'Pulmonary function test analysis to identify obstructive and restrictive patterns',
      'Explainable region highlighting showing exactly where abnormalities were detected',
    ],
    technology: 'Yamai Pulmo utilizes deep convolutional neural networks with attention mechanisms trained on large-scale chest imaging databases. Our 3D analysis capabilities for CT scans enable precise nodule detection and volumetric measurement. Explainability is achieved through saliency maps and bounding box visualizations that highlight regions of concern.',
    roadmap: [
      {
        title: 'Algorithm Development (2026-2027)',
        description: 'Train models on diverse chest imaging datasets covering multiple conditions',
      },
      {
        title: 'Radiologist Validation (2027-2028)',
        description: 'Extensive testing against expert radiologist interpretations',
      },
      {
        title: 'Integration with PACS Systems (2028-2029)',
        description: 'Seamless integration into hospital Picture Archiving and Communication Systems',
      },
      {
        title: 'Commercial Deployment (2029-2030)',
        description: 'Rollout to healthcare facilities across Europe',
      },
    ],
  };

  return <ProjectTemplate project={project} />;
};

export default Pulmo;